import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from '../../../../services/auth/auth.service';
import {RefundTicketRange} from '../../../../generated/sales-terminal-client';
import {RefundService} from '../../../../services/refund/refund.service';
import {CartService} from '../../../../services/cart/cart.service';
import {StorageService} from '../../../../services/storage/storage.service';
import {RouteService} from '../../../../services/route/route.service';
import {Privileges} from '../../../admin/privileges/privileges.constants';

@Component({
  selector: 'app-refund-dialog',
  templateUrl: './refund-dialog.component.html'
})
export class RefundDialogComponent {
  private _eventId: number;
  public title = 'general.api_cart_refund_tickets_by_id';
  public exchange: boolean;
  public ticketRangeStart: string;
  public ticketRangeEnd: string;
  public Privileges = Privileges;

  constructor(public dialogRef: MatDialogRef<RefundDialogComponent>,
              public authService: AuthService,
              private refundService: RefundService,
              private storageService: StorageService,
              private routeService: RouteService,
              private cartService: CartService,
              @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.exchange = data.exchange;
    this._eventId = data.eventId;
    if (this.exchange) {
      this.title = 'general.api_cart_exchange_tickets_by_id';
    }
  }

  get checkTicketRange(): boolean {
    return this.ticketRangeStart?.length && (!this.ticketRangeEnd || parseFloat(this.ticketRangeEnd) >= parseFloat(this.ticketRangeStart));
  }

  public addTicketRange(): void {
    if (!this.ticketRangeEnd) {
      this.ticketRangeEnd = this.ticketRangeStart;
    }
    const data: RefundTicketRange = {
      eventId: this._eventId,
      rangeStart: parseFloat(this.ticketRangeStart),
      rangeEnd: parseFloat(this.ticketRangeEnd)
    };
    this.refundService.addTicketsRange(data).subscribe(_ => {
      this.cartService.lastEventId = this._eventId;
      if (this.exchange) {
        this.storageService.set(RefundService.STORAGE_REFUND_EXCHANGE, true);
      } else {
        this.storageService.set(RefundService.STORAGE_REFUND_EXCHANGE, false);
      }
      this.dialogRef.close();
      this.routeService.navigate('/app/sales-terminal/refund');
    });
  }
}
